import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const currentLang = i18n.language || 'uk';

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      background: 'rgba(0, 255, 255, 0.1)',
      padding: '6px 12px',
      borderRadius: '20px',
      border: '1px solid rgba(0, 255, 255, 0.2)'
    }}>
      <Globe size={16} color="#00ffff" />
      <button
        onClick={() => changeLanguage('uk')}
        style={{
          background: currentLang === 'uk' ? '#00ffff' : 'transparent',
          color: currentLang === 'uk' ? '#000' : '#00ffff',
          border: 'none',
          padding: '4px 10px',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
      >
        UA
      </button>
      <button
        onClick={() => changeLanguage('en')}
        style={{
          background: currentLang === 'en' ? '#00ffff' : 'transparent',
          color: currentLang === 'en' ? '#000' : '#00ffff',
          border: 'none',
          padding: '4px 10px',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
